export default __webpack_public_path__ + "static/media/circleClock.652982fb.png";